<div class="form-body-desktop">
  <fr-isc-form Id="update-deployment" [FDN]="FDN" [formModel]="data" [mode]="'edit'" [buttons]="buttons">
  </fr-isc-form>
</div>
